/* FluffCo Search Modal
 * Live predictive search using Shopify's /search/suggest.json endpoint.
 * Mirrors the manus SearchModal.tsx behaviour 1:1.
 */
(function () {
  'use strict';

  var overlay, panel, input, body, clearBtn, popularBlock, resultsBlock, form;
  var debounceId = null;
  var inflight = null;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    overlay      = document.getElementById('fc-search-overlay');
    panel        = document.getElementById('fc-search-panel');
    input        = document.getElementById('fc-search-input');
    body         = document.getElementById('fc-search-body');
    clearBtn     = document.getElementById('fc-search-clear');
    popularBlock = document.getElementById('fc-search-popular');
    resultsBlock = document.getElementById('fc-search-results');
    form         = panel ? panel.querySelector('[data-fc-search-form]') : null;

    if (!overlay || !panel || !input) return;

    // Open triggers (any element with data-fc-search-open)
    document.querySelectorAll('[data-fc-search-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    // Close triggers
    document.querySelectorAll('[data-fc-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Escape to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // Input changes
    input.addEventListener('input', function () {
      toggleClear();
      scheduleSearch(input.value);
    });

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        toggleClear();
        scheduleSearch('');
        input.focus();
      });
    }

    // Form submit -> /search?q=...
    if (form) {
      form.addEventListener('submit', function (e) {
        var q = (input.value || '').trim();
        if (!q) { e.preventDefault(); return; }
        // let the form submit normally to /search
      });
    }
  }

  function isOpen() { return overlay && overlay.classList.contains('open'); }

  function open() {
    overlay.classList.add('open');
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
    input.value = '';
    showPopular();
    setTimeout(function () { input.focus(); }, 80);
  }

  function close() {
    overlay.classList.remove('open');
    panel.classList.remove('open');
    document.body.style.overflow = '';
    if (inflight && inflight.abort) inflight.abort();
  }

  function toggleClear() {
    if (!clearBtn) return;
    if (input.value) clearBtn.removeAttribute('hidden');
    else clearBtn.setAttribute('hidden', '');
  }

  function showPopular() {
    if (popularBlock) popularBlock.removeAttribute('hidden');
    if (resultsBlock) { resultsBlock.setAttribute('hidden', ''); resultsBlock.innerHTML = ''; }
  }

  function showResults() {
    if (popularBlock) popularBlock.setAttribute('hidden', '');
    if (resultsBlock) resultsBlock.removeAttribute('hidden');
  }

  function scheduleSearch(q) {
    if (debounceId) clearTimeout(debounceId);
    var query = (q || '').trim();
    if (!query) { showPopular(); return; }
    debounceId = setTimeout(function () { runSearch(query); }, 160);
  }

  function runSearch(query) {
    if (inflight && inflight.abort) inflight.abort();
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    inflight = ctrl;

    var params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,collection,page,article',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,body,tag',
      'resources[limit]': '8',
      'resources[limit_scope]': 'each'
    });
    var url = '/search/suggest.json?' + params.toString();

    fetch(url, ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderResults(query, (data && data.resources && data.resources.results) || {}); })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        renderError(query);
      });
  }

  function renderResults(query, results) {
    showResults();
    var products    = (results.products || []).slice(0, 5);
    var collections = (results.collections || []).slice(0, 4);
    var pages       = (results.pages || []).slice(0, 4);
    var articles    = (results.articles || []).slice(0, 4);
    var pageish     = collections.concat(pages).concat(articles).slice(0, 4);

    if (!products.length && !pageish.length) {
      resultsBlock.innerHTML =
        '<div class="fc-search-empty">No results found for "' + escapeHtml(query) + '"</div>';
      return;
    }

    var html = '';

    if (products.length) {
      html += '<div class="fc-search-results-group">';
      html += '<p class="fc-search-label">Products</p>';
      html += '<div class="fc-search-results-list">';
      products.forEach(function (p) { html += productRow(p); });
      html += '</div></div>';
    }

    if (pageish.length) {
      html += '<div class="fc-search-results-group">';
      html += '<p class="fc-search-label">Pages &amp; Collections</p>';
      html += '<div class="fc-search-results-list">';
      pageish.forEach(function (pg) { html += pageRow(pg); });
      html += '</div></div>';
    }

    // View all
    html +=
      '<a class="fc-search-viewall" href="/search?q=' + encodeURIComponent(query) + '">' +
        'View all results for "' + escapeHtml(query) + '"' +
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
      '</a>';

    resultsBlock.innerHTML = html;
  }

  function productRow(p) {
    var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
    var name = p.title || '';
    var cat = p.product_type || p.vendor || '';
    var price = formatMoney(p.price_min != null ? p.price_min : p.price);
    return (
      '<a class="fc-search-result" href="' + escapeAttr(p.url) + '">' +
        '<div class="fc-search-result__thumb' + (img ? '' : ' fc-search-result__thumb--empty') + '">' +
          (img ? '<img src="' + escapeAttr(img) + '" alt="' + escapeAttr(name) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="fc-search-result__body">' +
          '<div class="fc-search-result__title">' + escapeHtml(name) + '</div>' +
          (cat ? '<div class="fc-search-result__sub">' + escapeHtml(cat) + '</div>' : '') +
        '</div>' +
        (price ? '<div class="fc-search-result__price">' + price + '</div>' : '') +
      '</a>'
    );
  }

  function pageRow(item) {
    var icon = svgIconFor(item);
    var sub = item.body || item.summary_html || (item.published_at ? 'Article' : 'Page');
    sub = stripTags(String(sub)).slice(0, 80);
    return (
      '<a class="fc-search-result" href="' + escapeAttr(item.url) + '">' +
        '<div class="fc-search-result__thumb">' + icon + '</div>' +
        '<div class="fc-search-result__body">' +
          '<div class="fc-search-result__title">' + escapeHtml(item.title || '') + '</div>' +
          (sub ? '<div class="fc-search-result__sub">' + escapeHtml(sub) + '</div>' : '') +
        '</div>' +
        '<svg class="fc-search-result__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</a>'
    );
  }

  function svgIconFor(item) {
    // collections have products_count; articles have published_at; pages have neither
    var color = 'color:var(--fluffco-primary-blue,#434780);opacity:0.7';
    if (item.products_count != null) {
      // Grid (collection)
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="' + color + '"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>';
    }
    if (item.published_at) {
      // Book (article)
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="' + color + '"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>';
    }
    // FileText (page)
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="' + color + '"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>';
  }

  function renderError(query) {
    showResults();
    resultsBlock.innerHTML =
      '<div class="fc-search-empty">Couldn’t search right now. Try again in a moment.</div>';
  }

  // ── helpers ──────────────────────────────────────────────
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return escapeHtml(s); }
  function stripTags(s) { return String(s || '').replace(/<[^>]*>/g, ''); }
  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    // Shopify's suggest API returns prices in cents (or dollars depending on shop). Treat as cents.
    var v = Number(cents);
    // If value seems too small (likely already dollars), don't divide
    if (v < 1000 && v % 1 !== 0) {
      // already a decimal
      return '$' + v.toFixed(2);
    }
    return '$' + (v / 100).toFixed(2);
  }
})();
